import { deleteCookie } from '@/commons/cookies';

export default (vuexstore: any) => {
    vuexstore.subscribe((mutation: any, state: any) => {
        const affectedMutations = [
            'cart/setQty',
            'cart/deleteItem',
            'cart/reset',
        ];

        if (affectedMutations.includes(mutation.type)) {
            window.localStorage.removeItem('mage-cache-storage');
            deleteCookie('private_content_version');
        }
    });
};
